export default __webpack_public_path__ + "static/media/html-r-bg (1).516d76d0.png";